import { api } from "./client";
import type { RawReading, Reading } from "@/types";

export interface ReadingsQuery {
  from?: string;     // ISO8601
  to?: string;
  bucket?: string;   // ex: "1m", "5m", "1h"
  limit?: number;
}

export interface EquipmentReadingsQuery extends ReadingsQuery {
  role?: string;     // filtra device pelo role
}

export const readingsApi = {
  async deviceRaw(deviceId: string, q?: ReadingsQuery): Promise<RawReading[]> {
    const { data } = await api.get<RawReading[]>(`/devices/${deviceId}/readings`, { params: q });
    return data;
  },

  async deviceField(
    deviceId: string,
    field: string,
    q?: ReadingsQuery,
  ): Promise<Reading[]> {
    const { data } = await api.get<Reading[]>(
      `/devices/${deviceId}/readings/${encodeURIComponent(field)}`,
      { params: q },
    );
    return data;
  },

  async equipmentField(
    equipmentId: string,
    field: string,
    q?: EquipmentReadingsQuery,
  ): Promise<Reading[]> {
    const { data } = await api.get<Reading[]>(
      `/equipments/${equipmentId}/readings/${encodeURIComponent(field)}`,
      { params: q },
    );
    return data;
  },
};
